
import { AppIcons } from "../../../data/appIcons";
import { GridColumnType } from "../../../data/gridColumnType";

export const CorporateMembersListConfig = {
  columns: [
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Organisation Category",
      fieldName: "organisationCategoryName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Membership Type",
      fieldName: "membershipType",
      colType: GridColumnType.Text,
    },
    {
      name: "Application Type",
      fieldName: "applicationType",
      colType: GridColumnType.Text,
    },
    {
      name: "Membership Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "VIEW",
          iconName: AppIcons.editIconNew,
          onViewAction: (data) => {
            alert("called permissions");
          },
        }
      ],
    },
  ],
};
